






























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop } from 'vue-property-decorator'
import QSelect from 'quasar/src/components/select/QSelect.js';

@Component({
  inheritAttrs: false
})
export default class BaseSelect extends Vue {
  @Prop({ default: '' }) readonly label!: string
  @Prop({ default: '' }) readonly selectClass!: string
  @Prop({ default: 'انتخاب کنید' }) readonly placeholder!: string
  @Prop({ default: false }) readonly typeMode!: boolean
  @Prop() value: string | number | undefined
  @Prop() options: string[] | object[] | undefined

  $refs: {
    'q-select': QSelect
  }

  mounted() { //TODO
    this.$refs['q-select'].$el.classList.remove('q-field--auto-height')
  }

  @Emit('input')
  updateValue() {
  }

  checkPlaceholder(value) {
    return (String(value) != '' && String(value) != 'null')
  }
}
